import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';

export default class NavigationLoadingService extends Service {
  @service declare router: RouterService;

  @tracked isLoading = false;

  private _onWillChange = (transition: Transition) => {
    if (transition.from?.name === transition.to?.name) {
      return;
    }
    this.isLoading = true;

    // ensure we catch scenarios like `transition.abort()` and avoid forever loading
    transition.catch(() => {
      this.isLoading = false;
    });
  };

  private _onDidChange = () => {
    this.isLoading = false;
  };

  constructor(...args: []) {
    super(...args);
    this.router.on('routeWillChange', this._onWillChange);
    this.router.on('routeDidChange', this._onDidChange);
  }

  willDestroy(): void {
    super.willDestroy();
    this.router.off('routeWillChange', this._onWillChange);
    this.router.off('routeDidChange', this._onDidChange);
  }
}

declare module '@ember/service' {
  interface Registry {
    'navigation-loading': NavigationLoadingService;
  }
}
